import { AgentToolCall } from '@multiplayer-app/ai-agent-types'
import { ToolApprovalButtons } from './ToolApprovalButtons'
import { useAgentRuntime, useAgentStore } from '@/context/AgentProvider'
import { UiChatStatus, mapPersistedStatusToUiStatus } from '@/state/useAgentStore'
import { ApprovalStatusInline } from './ApprovalStatusInline'

interface ToolApprovalProps {
  call: AgentToolCall
  messageId: string
  chatId: string
}

const ToolApproval = ({ call, messageId, chatId }: ToolApprovalProps) => {
  const runtime = useAgentRuntime()
  const upsertChat = useAgentStore((state) => state.upsertChat)
  const setChatStatus = useAgentStore((state) => state.setChatStatus)
  const shouldShowApprovalInDebug = runtime.config.debug && Boolean(call.approvalId)
  const shouldRenderApproval = (call.requiresConfirmation && call.approvalId) || shouldShowApprovalInDebug
  const requiresApproval = shouldRenderApproval && call.approved === undefined
  const hasApprovalStatus = shouldRenderApproval && call.approved !== undefined

  const handleApprovalSent = async () => {
    // Refresh chat to get updated tool call status
    try {
      const updatedChat = await runtime.transport.getChat(chatId)
      upsertChat(updatedChat)
      setChatStatus(chatId, mapPersistedStatusToUiStatus(updatedChat.status))
    } catch (error) {
      console.error('Failed to refresh chat after approval:', error)
      setChatStatus(chatId, UiChatStatus.Idle)
    }
  }

  if (!requiresApproval && !hasApprovalStatus) return null

  return (
    <div className='mp-agent-tool-approval'>
      {requiresApproval && (
        <ToolApprovalButtons call={call} messageId={messageId} chatId={chatId} onApprovalSent={handleApprovalSent} />
      )}
      {hasApprovalStatus && <ApprovalStatusInline call={call} />}
    </div>
  )
}

export default ToolApproval
